import { render, staticRenderFns } from "./InventoryHistory.vue?vue&type=template&id=60e1a29a&scoped=true&"
import script from "./InventoryHistory.vue?vue&type=script&lang=js&"
export * from "./InventoryHistory.vue?vue&type=script&lang=js&"
import style0 from "./InventoryHistory.vue?vue&type=style&index=0&id=60e1a29a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e1a29a",
  null
  
)

export default component.exports